export const USER_TYPE = {
  HOMECARE: 1,
  COOPERATIVE: 2,
  PROFESSIONAL: 3
};
